import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
// import "../blog/Blog.css";


// Import the background image
import backgroundImage from "../../assets/images/slide2.jpeg";

const Top = () => {
    const sectionStyle = {
        backgroundImage: `url(${backgroundImage})`,
        backgroundColor: '#a20000',
        backgroundBlendMode: 'multiply',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        height: '250px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
    };

    return (
        <>
            <section
                className="elementor-section elementor-top-section elementor-element elementor-element-d29e141 elementor-section-full_width elementor-section-stretched elementor-section-height-default elementor-section-height-default"
                data-id="d29e141"
                data-element_type="section"
                data-settings="{&quot;background_background&quot;:&quot;classic&quot;,&quot;stretch_section&quot;:&quot;section-stretched&quot;}"
                style={{ ...sectionStyle }}
            >
                <div className="elementor-background-overlay"></div>
                <Container className="elementor-container elementor-column-gap-no">
                    <Row className="elementor-row">
                        <Col className="elementor-column elementor-col-12 elementor-top-column elementor-element elementor-element-0a1c64f" data-id="0a1c64f" data-element_type="column">
                            <div className="elementor-column-wrap elementor-element-populated">
                                <div className="elementor-widget-wrap">
                                    <div
                                        className="elementor-element elementor-element-b12b60d elementor-widget elementor-widget-modina_section_title"
                                        data-id="b12b60d"
                                        data-element_type="widget"
                                        data-widget_type="modina_section_title.default"
                                    >
                                        <div className="elementor-widget-container">
                                            <div className="block-contents text-center">
                                                <div className="section-title">
                                                    <h2 >About Us</h2>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
            <Container className="top-summary" style={{ padding: "30px", color: "grey" }}>
                <Row>
                    <Col>
                        <p>
                            Gautam Solar is one of India’s leading solar module manufacturers, consistently ranked among the country’s Top 10 manufacturers (as per JMK Research & Analytics – RE Update Q4 2024 and other industry reports). With over 28 years of solar industry expertise, we operate state-of-the-art factories in Haridwar (Uttarakhand) and Bhiwani (Haryana), supported by a corporate office in New Delhi.

               <br />
               <br />
                            By December 2025, we successfully expanded our solar module manufacturing capacity to 5 GW, and are currently developing a 2 GW TOPCon solar cell manufacturing facility as part of our forward integration plan. Our product portfolio includes advanced Mono PERC and next-generation N-Type TOPCon solar modules – including our latest Rectangular TOPCon bifacial modules with outputs up to 610-630 Wp and efficiencies as high as 23.32%.
                            <br />
                            <br />
                        </p>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            All Gautam Solar modules are ALMM-listed, BIS-approved for the Indian market and certified as per UL/IEC/EN standards for exports to the US and Europe. We hold multiple patents and IPs in solar manufacturing and have integrated AI-based defect detection systems in our processes to ensure the highest product reliability. Backed by a 12-year product warranty and 30-year performance warranty, our modules are engineered to deliver maximum energy yield, making us a trusted partner for solar developers and installers worldwide.
                        </p>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default Top;


